module.exports = __webpack_public_path__ + "static/00020.c062059f.jpg";